import { CircularProgress, Divider, Flex, HStack, Text, VStack } from '@chakra-ui/react'
import { ScreenContext, useAuth } from '@hb/react'
import {
  ActionButton,
  ConsentFormsStatusPatientView,
  DocumentFormTroubleSigningModal,
  PageContainer,
  SignInToView,
  useConsentFormsStatus,
} from '@hb/react-web'
import { useContext, useState } from 'react'

export const MyConsentForms = () => {
  const { contentWidth } = useContext(ScreenContext)
  const { authUser, loading, user } = useAuth()
  const [troubleSigningModalOpen, setTroubleSigningModalOpen] = useState(false)
  const consentFormsStatus = useConsentFormsStatus(user?.id ?? null, user, null)
  if (!authUser) {
    return <SignInToView message="Sign in to view your consent forms" />
  }
  const body = loading ? (
    <HStack p={2} bg="white" _dark={{ bg: 'gray.900' }} borderRadius={6} boxShadow="md">
      <CircularProgress isIndeterminate />
      <Text> Loading your account... </Text>
    </HStack>
  ) : (
    <Flex flex={1} w="100%" overflowY="auto" position="relative" direction="column" align="center">
      <ConsentFormsStatusPatientView
        patientId={authUser.uid}
        consentFormsStatus={consentFormsStatus}
      />
    </Flex>
  )

  return (
    <PageContainer>
      <VStack
        flexDir="column"
        w="100%"
        width={contentWidth}
        bg="white"
        _dark={{ bg: 'gray.800' }}
        alignItems="flex-start"
        spacing={0}
        divider={<Divider />}>
        <Flex
          px={3}
          py={2}
          w="100%"
          justify="space-between"
          bg="gray.50"
          _dark={{ bg: 'gray.800' }}>
          <Text fontSize="xl" opacity={0.8} fontWeight={500}>
            My Consent Forms
          </Text>
          <ActionButton
            colorScheme="gray"
            size="sm"
            onClick={() => setTroubleSigningModalOpen(true)}>
            Having trouble signing consent forms?
          </ActionButton>
        </Flex>
        {body}
      </VStack>
      <DocumentFormTroubleSigningModal
        isOpen={troubleSigningModalOpen}
        onClose={() => setTroubleSigningModalOpen(false)}
        document={undefined}
      />
    </PageContainer>
  )
}
